export type PropertyStatus = "analysed" | "failed" | "missing_data" | string

/**
 * Title-cases a UK address string.
 * Words containing digits (house numbers, postcode segments) are uppercased
 * to preserve formats like "E7", "8PG", "SW1A".
 */
export const titleizeAddress = (address: string): string =>
  address
    .split(" ")
    .map((word) =>
      /\d/.test(word)
        ? word.toUpperCase()
        : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    )
    .join(" ")

export const getStatusColor = (status: PropertyStatus) => {
  switch (status) {
    case "analysed":
      return "green"
    case "failed":
      return "red"
    case "missing_data":
      return "orange"
    default:
      return "gray"
  }
}

export const getStatusDisplayText = (status: PropertyStatus) => {
  switch (status) {
    case "analysed":
      return "Analysed"
    case "failed":
      return "Failed"
    case "missing_data":
      return "Missing data"
    default:
      return "Unknown"
  }
}

export const getEpcRatingColor = (rating: string | undefined): string => {
  if (!rating) return "gray"
  
  const normalizedRating = rating.toUpperCase().trim()
  switch (normalizedRating) {
    case "A":
      return "green"
    case "B":
      return "teal"
    case "C":
      return "yellow"
    case "D":
      return "orange"
    case "E":
      return "orange"
    case "F":
      return "red"
    case "G":
      return "red"
    default:
      return "gray"
  }
}
